import { Session } from '@/types/session.types';
import { ProjectStateReducerCreator } from '../types';
import { GetSession } from '@/connection/projects/get-session';
import { serializeError } from '@/store/utils/serialize-error';
import toastTrigger from '@ui/toast/toast-trigger';
import { RootState } from '@/store/root-state';
import { EToastTypes } from '@ui/toast/toast.types';

const loadWorkingSessionReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (
      { sessionId, returnStoreStateIfExists }: { sessionId: number; returnStoreStateIfExists: boolean },
      { rejectWithValue, getState }
    ) => {
      if (returnStoreStateIfExists) {
        const state = getState() as RootState;
        const session = state.project?.workingSession as Session | null;
        if (session && session.session === sessionId) {
          return session;
        }
      }
      try {
        return await GetSession(sessionId);
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.workingSession = action.payload;
        state.loadingWorkingSession = false;
      },
      pending: (state) => {
        state.loadingWorkingSession = true;
      },
      rejected: (state, action) => {
        state.loadingWorkingSession = false;
        state.loadingWorkingSessionError = action.error.message;
        toastTrigger('Unable to load session', {
          type: EToastTypes.error,
          autoClose: 5000,
        });
      },
    }
  );
};

export default loadWorkingSessionReducer;
